export const getFullProductsFieldName = (name: string) => `${name}Array`;
